import React from 'react';
import { Table, UncontrolledTooltip } from 'reactstrap';
import moment from 'moment/min/moment-with-locales';
import * as utils from '../../Services/utils';
import { InfoTag } from '../shared/infoTag';
import { useTranslation } from 'react-i18next';
import { basicDateFormat } from '../../Helpers/dateTimeHelper';

const CompetencesTable = ({ competences, counting, onItemClicked }) => {
  const { t, i18n } = useTranslation('translations');

  return (
    // TODO: I want that this table has fixed width, but scroller on the bottom must appear when the screen is not wide enough
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <Table striped bordered style={{ minWidth: '800px' }}>
        <thead>
          <tr>
            <th></th>
            <th hidden>ID</th>
            <th>{t('competences.NAME')}</th>
            {/* <th>Field</th> */}
            <th>
              {t('common.TYPE')}&nbsp;
              <InfoTag id="allCompetences" lng={i18n.language}></InfoTag>
            </th>
            <th>{t('common.ADDED')}</th>
            <th>{t('common.MODIFIED')}</th>
            <th style={{ width: '160px' }}></th>
          </tr>
        </thead>
        <tbody>
          {competences.map((item, index) => (
            <tr key={item.id}>
              <td>{counting + index + 1}</td>
              <td hidden>{item.id}</td>
              <td>{item.name}</td>
              <td>
                <div className={utils.getBadgeColor(item.competenceType)}>
                  {utils.translateCompetenceType(item.competenceType)}
                </div>
              </td>
              <td>{moment.utc(item.created).format(basicDateFormat)}</td>
              <td>{moment.utc(item.modified).fromNow()}</td>
              <td className="text-center">
                <em
                  id={`eyeButton-${index}`}
                  style={{ cursor: 'pointer' }}
                  className="fa-2x mr-2 fas icon-eye icon-hover-effect-no-color"
                  onClick={() => onItemClicked(item, 'view')}
                >
                  <UncontrolledTooltip delay={{ show: 300, hide: 0 }} placement="left" target={`eyeButton-${index}`}>
                    {t('common.DETAILS')}
                  </UncontrolledTooltip>
                </em>
                <em
                  id={`pencilButton-${index}`}
                  style={{ cursor: 'pointer' }}
                  className="fa-2x mr-2 fas icon-pencil icon-hover-effect-no-color"
                  onClick={() => onItemClicked(item, 'edit')}
                >
                  <UncontrolledTooltip
                    delay={{ show: 300, hide: 0 }}
                    placement="left"
                    fade={true}
                    autohide={false}
                    target={`pencilButton-${index}`}
                  >
                    {t('common.EDIT')}
                  </UncontrolledTooltip>
                </em>
                <em
                  id={`trashButtonCompetences-${index}`}
                  data-cy={`trashButtonCompetences-${index}`}
                  style={{ cursor: 'pointer' }}
                  className="fa-2x mr-2 fas icon-trash icon-hover-effect-no-color"
                  onClick={() => onItemClicked(item, 'delete')}
                />
                <UncontrolledTooltip
                  delay={{ show: 300, hide: 0 }}
                  placement="left"
                  target={`trashButtonCompetences-${index}`}
                >
                  {t('common.DELETE')}
                </UncontrolledTooltip>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default CompetencesTable;
